export function getDataProperty(propertyName: string): string {
    const property = document
        .querySelector(`div[${propertyName}]`);

    if (property === null) {
        return '';
    }

    return property.getAttribute(propertyName) as string;
}

export function getMetaTagProperty(name: string): string {
    const metaTags = document.getElementsByTagName('meta');

    for (const metaTag of metaTags) {
        if (metaTag.getAttribute('name') === name) {
            return metaTag.content;
        }
    }

    return '';
}

export function groupByAmount<TItem>(
    source: TItem[],
    amount: number,
    specialCase: (item: TItem) => boolean
) {
    const groups = [] as TItem[][];
    let currentGroups = [] as TItem[];

    source.forEach((item, index) => {
        // This is a special case where it needs its own group
        if (specialCase(item)) {
            // If the current group being built already contains items
            // Then flush that group out immediately first
            if (currentGroups.length > 0) {
                groups.push(currentGroups);
                currentGroups = [] as TItem[];
            }

            currentGroups.push(item);
            groups.push(currentGroups);
            currentGroups = [] as TItem[];
        } else {
            currentGroups.push(item);

            if ((currentGroups.length >= amount || index === source.length - 1)) {
                groups.push(currentGroups);
                currentGroups = [] as TItem[];
            }
        }
    });

    return groups;
}

export function groupWhen<TItem>(
    source: TItem[],
    groupPredicate: (item: TItem, currentGroup: TItem[], index: number, source: TItem[]) => boolean
): TItem[][] {
    const groups = [] as TItem[][];
    let currentGroup = [] as TItem[];

    source.forEach((item, index) => {
        currentGroup.push(item);

        if (groupPredicate(item, currentGroup, index, source)) {
            groups.push(currentGroup);
            currentGroup = [] as TItem[];
        }
    });

    return groups;
}

export function getQueryParams(qs: string): { [id: string]: string } {
    qs = qs.split('+').join(' ');

    const params: { [id: string]: string } = {};
    const re = /[?&]?([^=]+)=([^&]*)/g;
    let tokens: RegExpExecArray | null;

    // tslint:disable-next-line:no-conditional-assignment
    while ((tokens = re.exec(qs))) {
        const firstParam = decodeURIComponent(tokens[1]);
        params[firstParam] = decodeURIComponent(tokens[2]);
    }

    return params;
}

export function getCookie(name: string): any {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
        const cookieString = parts.pop();

        if (cookieString === undefined) {
            return '';
        }

        return cookieString
            .split(';')
            .shift();
    }
}

export const queryParams: { [id: string]: string } = getQueryParams(document.location.search);
